<template>
  <div class="mb48 orderSearch tms-style">
    <el-card class="mtf1">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" label-position="left">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.ContainerNo')">
              <el-input v-model="searchForm.TankNo" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('TankService.Portofdischarge')">
              <el-input v-model="searchForm.PodName" size="small" style="width:90%" class="custom-input" />
            </el-form-item>
          </el-col>
           <el-col :span="6">
            <el-form-item :label="$t('TankService.DYProperty27')">
              <el-select v-model="searchForm.Backhaul" size="small" style="width:90%;border: none;">
                <el-option
                  v-for="item in Object.values(Backhaul_S)"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="custom-flex-center" style="margin-top: 20px">
          <el-button type="primary" size="small" class="buttonSize" icon="el-icon-search" :loading="fullscreenLoading" @click="query">{{ $t('TankService.Inquiry') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-refresh-right" :loading="fullscreenLoading" @click="empty">{{ $t('TankService.Reset') }}</el-button>
          <el-button size="small" class="search buttonSize" icon="el-icon-download" :loading="fullscreenLoading" @click="exportData">{{ $t('TankService.Export') }}</el-button>
        </div>
      </el-form>
    </el-card>
    <el-card class="mt10">
      <div class="custom-flex-space-between mb20">
        <div style=" font-size: 16px">{{ $t('TankService.DetailedView') }}</div>
      </div>
      <div style="padding: 0px 20px 20px 20px">
        <el-table
          ref="orderTable"
          v-loading="loading"
          stripe
          :data="dataList"
        >
          <el-table-column type="index" width="50" :index="getIndex" :label="$t('TankService.SerialNumber')" />
          <el-table-column prop="TankNo" width="120" :label="$t('TankService.DYProperty1')" />
          <el-table-column prop="Inspection" width="120" :label="$t('TankService.DYProperty2')"/>
          <el-table-column prop="PodName" width="170" :label="$t('TankService.DYProperty3')"/>
           <el-table-column prop="GateOut" width="120" :label="$t('TankService.DYProperty22')"
          :formatter="(row)=>{
              return conversionyyyyMMdd(row.GateOut)
            }"
           />
           <el-table-column prop="Backhaul" width="100" :label="$t('TankService.DYProperty27')"/>
           <el-table-column prop="BackhaulTT" width="100" :label="$t('TankService.DYProperty23')"/>
           <el-table-column prop="BackhaulETA" width="110" :label="$t('TankService.DYProperty24')"
          :formatter="(row)=>{
              return conversionyyyyMMdd(row.BackhaulETA)
            }"
           />
            <el-table-column prop="ReadyToUse" width="110" :label="$t('TankService.DYProperty25')"
          :formatter="(row)=>{
              return conversionyyyyMMdd(row.ReadyToUse)
            }"
           />
            <el-table-column prop="LocationATM" width="600" :label="$t('TankService.DYProperty26')"/>
          </el-table>
      </div>
    </el-card>
    <div class="footPage">
      <el-pagination
        class="custom-el-pagination floatR"
        background
        layout="sizes, prev, pager, next,total"
        :current-page.sync="curPageIndex"
        :page-sizes="[10,20, 50, 100]"
        :page-size="pageSize"
        :total="listTotalCount"
        @size-change="pageSizeChangeHandle"
        @current-change="curPageChangeHandle"
      />
      <div class="disclaimer" :style="{left: lang == 'zh' ? '210px' : '210px' }">
        <div>
        <p>&nbsp;<img src="@/assets/wms/disclaimerIcon.svg" style="display:inline" />&nbsp;{{ $t('TankService.Content1') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReturnKeyAccountPageList } from '@/api/gmsTank.js'
import OrderStep from '@/components/fms/orderStep/index.vue'
import { convertYMD, conversionyyyyMMdd, parseTime, dateAdds } from '@/utils/index'
import { ISStr, EnumValueLocal } from '@/utils/isClass'
import { exportToExcel } from '@/vendor/Export2Excel.js'
import { tableRowClassName } from '@/utils/fms/tableClass'
import i18n from '@/i18n/i18n'

export default {
  components: { OrderStep },
  props: {
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'zh',
      Backhaul_S: [
        { name: i18n.t('TankService.All'), id: '' },
        { name: i18n.t('TankService.YES'), id: 'Yes' },
        { name: i18n.t('TankService.NO'), id: 'No' },
      ],
      EnumValueLocal,
      ISStr,
      convertYMD,
      conversionyyyyMMdd,
      tableRowClassName,
      loading: false,
      showType: true,
      fullscreenLoading: false,
      activeNames: [],
      dataList: [],
      dialogVisible: false,
      searchForm: JSON.parse(JSON.stringify({
        TankNo: '',
        Backhaul: '',
        PodName: '',
        Customer_Code: this.customerCode,
      })),
      searchSendCarForm: JSON.parse(JSON.stringify({
        TankNo: '',
        Backhaul: '',
        PodName: '',
        Customer_Code: this.customerCode,
      })), // 搜索条件
      listTotalCount: 0,
      curPageIndex: 1,
      pageIndex: 1,
      pageSize: 10,
      tankfileDialogShow: false,
      curTitle: i18n.t('TankService.DownloadAttachment'),
      milestoneTitle: i18n.t('TankService.SubscriptionInformation'),
      // 日期时间范围在一个月以内
      pickerOptions: {
        disabledDate: (time) => {
          if (this.disabledDateRange && this.disabledDateRange.length > 0) {
            return (
              time.getTime() < this.disabledDateRange[0].getTime() ||
              time.getTime() > this.disabledDateRange[1].getTime()
            )
          } else {
            return false
          }
        },
        onPick: (picks) => {
          if (picks.maxDate) {
            this.disabledDateRange = []
          } else {
            this.disabledDateRange = [
              dateAdds(picks.minDate, -30, 'd'),
              dateAdds(picks.minDate, 30, 'd')
            ]
          }
        }
      }
    }
  },
  computed: {},
  mounted() {
    this.lang = this.$ls.get('lang');
    this.init()
  },
  methods: {
    onteOrderFormSubmit() {
      this.getList()
    },
    init() {
      this.getList()
    },
    getIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    /**  查询 */
    query() {
      this.fullscreenLoading = true
      var _this = this
      this.pageIndex = 1
      this.searchSendCarForm = JSON.parse(JSON.stringify(_this.searchForm))
      this.getList()
    },
    /**  清空 */
    empty() {
      this.searchForm = JSON.parse(JSON.stringify({
        TankNo: '',
        Backhaul: '',
        PodName: '',
        Customer_Code: this.customerCode,
      }))
      this.searchSendCarForm = JSON.parse(JSON.stringify({
        TankNo: '',
        Backhaul: '',
        PodName: '',
        Customer_Code: this.customerCode,
      }))
    },
    /**  列表查询 */
    getList() {
      this.loading = true
      const pagination = {}
      pagination.pageIndex = this.pageIndex
      pagination.pagesize = this.pageSize
      pagination.sort = 'CreateDT'
      const data = {}
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      data.lang = this.lang
      getReturnKeyAccountPageList(data).then((res) => {
        var data = JSON.parse(res.data)
        this.listTotalCount = data?.total
        const result = data?.rows ?? []
        this.dataList = result
        this.activeNames = []
        this.curPageIndex = this.pageIndex
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        this.loading = false
        this.fullscreenLoading = false
        console.log(err)
      })
    },
    pageSizeChangeHandle(size) {
      this.pageSize = size
      this.pageIndex = 1
      this.getList()
    },
    curPageChangeHandle(pageIndex) {
      this.pageIndex = pageIndex
      this.getList()
    },
    /** 导出 */
    exportData() {
      this.loading = true
      this.fullscreenLoading = true
      const pagination = {}
      // 导出全部查询数据
      pagination.pageIndex = 1
      pagination.pagesize = this.listTotalCount
      pagination.sort = 'CreateDT'
      const data = {}
      data.pagination = JSON.stringify(pagination)
      data.queryJson = JSON.stringify(this.searchSendCarForm)
      data.lang = this.lang
      getReturnKeyAccountPageList(data).then((res) => {
        var data = JSON.parse(res.data)
        this.listTotalCount = data?.total
        const result = data?.rows ?? []
        // 转换数据为工作表对象
        var dataList = result.map(x => {
          var data = {
            TankNo: x.TankNo,
            Inspection: x.Inspection,
            PodName: x.PodName,
            GateOut: conversionyyyyMMdd(x.GateOut),
            Backhaul: x.Backhaul,
            BackhaulTT: x.BackhaulTT,
            BackhaulETA: conversionyyyyMMdd(x.BackhaulETA),
            ReadyToUse: conversionyyyyMMdd(x.ReadyToUse),
            LocationATM: x.LocationATM
          }
          return data
        })
        var column = [
          { lable: i18n.t('TankService.DYProperty1'), width: 20 },
          { lable: i18n.t('TankService.DYProperty2'), width: 20 },
          { lable: i18n.t('TankService.DYProperty3'), width: 20 },
          { lable: i18n.t('TankService.DYProperty22'), width: 20 },
          { lable: i18n.t('TankService.DYProperty27'), width: 20 },
          { lable: i18n.t('TankService.DYProperty23'), width: 20 },
          { lable: i18n.t('TankService.DYProperty24'), width: 20 },
          { lable: i18n.t('TankService.DYProperty25'), width: 20 },
          { lable: i18n.t('TankService.DYProperty26'), width: 20 },
        ]
        exportToExcel({ column, dataList, filename: i18n.t('TankService.TankReturnDetails') + '_' + this.convertYYYMMDD() })
        this.loading = false
        this.fullscreenLoading = false
      }).catch(err => {
        this.loading = false
        this.fullscreenLoading = false
        console.log(err)
      })

    },
    convertYYYMMDD() {
      try {
        const d = new Date()
        const year = d.getFullYear()
        const month = this.plusZero(d.getMonth() + 1)
        const day = this.plusZero(d.getDate())
        return year + month + day
      } catch (err) {
        console.log(err.message)
        return time
      }
    },
    plusZero(val) {
      if (val >= 0 && val <= 9) {
        return '0' + val
      } else {
        return val
      }
    },
  }
}
</script>
<style scoped>
@import "~@/styles/fms/tableClass.scss";
.orderSearch >>> .el-date-editor .el-range-separator{
  width: initial;
  display: block !important;
}
.orderSearch >>> .el-form-item{
  margin-bottom: initial;
}
.orderSearch >>> .el-table .el-table__cell{
  padding: initial;
}

/* 公共样式提取至内部 开始*/
.custom-input >>> .el-input__inner {
  border: 1px solid #60aabc;
  max-width: 300px;
  background: #fff;
}
.custom-input >>> .el-range-input {
  background: #fff;
  max-width: 500px;
}

.custom-input.el-input__inner>>> {
  background: #f6f6f8;
}

.custom-input.el-date-editor {
  background: #f6f6f8;
}
.custom-input.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-range-input {
    background: white !important;
}

.custom-el-collapse {
  border: 0;
}
.custom-el-collapse .el-collapse-item {
    border-radius: 8px;
    margin-bottom: 13px;
    box-shadow: none;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__header {
  margin: 0;
  font-size: 16px;
  font-weight: normal !important;
  height: auto;
  color: #111827;
  background-color: #fff !important;
  border: 0 !important;
  border-radius: 8px !important;
  line-height: initial;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__wrap {
  border-top: 1px solid #dcdee2;
  border-radius: 0 0 8px 8px;
}
.custom-el-collapse .el-collapse-item >>> .el-collapse-item__content {
  padding-bottom: 0px !important;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  border-top: #fff;
}
.mtf1 >>> .el-card__body{
  padding: 20px 20px 20px 39px !important;
}
.mt10 {
  margin-top: 16px;
}
.mb20 {
  margin-bottom: 0px;
  padding: 10px 20px 10px 20px;
  border-radius: 4px 4px 0 0;
  border: 1px solid #ebeef5;
}
.ml18 {
  margin-left: 17px;
}
.mb48{
  margin-bottom: 48px;
}
.w100 {
  width: 100%;
}
.floatR {
  float: right;
}
.el-collapse .divTitle {
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}
.inline-block {
  display: inline-block;
}
.showType {
  width: 20px;
  height: 20px;
}
.footPage {
  z-index: 3;
  background-color: #fff;
  height: 48px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 36px;
  padding: 8px 16px;
}
/* 样式改版 */
.text-content {
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 使用省略号代替溢出部分 */
  white-space: nowrap; /* 不换行 */
}
.search{
  border: 1px solid #67B0C4 !important;
  border-color: #67B0C4 !important;
  color: #67B0C4;
}
.order-img{
  width: 24px !important;
  height: 30px !important;
  display: inline-block;
}
.mt10 >>> .el-card__body{
  padding: 0px !important;
}
.order-title{
  padding: 36px 45.5px 33px 32px;
  width: 100% !important;
}
.custom-el-collapse{
  background-color: aliceblue;
}
.order-label{
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 24px;
}
.order-text{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
}
.order-text-booking{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #67B0C4;
  border-radius: 6px;
  line-height: 22px;
}
.order-text-jobtype{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  line-height: 22px;
  background: #E8F3F6;
  color: #084156;
  border-radius: 6px;
  padding: 2px 10px 2px 10px;
}
.details-label1{
  width: 110px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value1{
  width: 200px;
}
.details-label2{
  width: 130px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value2{
  width: 220px;
}
.details-label3{
  width: 90px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
}
.details-value3{
  width: 240px;
}
.details-text{
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #666666;
  line-height: 22px;
  width: 350px;
}
.details-title{
  font-size: 16px;
  font-family: Source Han Sans SC, Source Han Sans SC-Bold;
  font-weight: 700;
  text-align: left;
  color: #333333;
  line-height: 24px;
  margin-bottom: 13px;
}
.custom-el-button span{
  display: flex !important;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
.custom-el-button img{
  width: 14px;
  height: 14px;
  margin-right: 5px;
}
.custom-el-collapse >>> .el-collapse-item__arrow {
  display: none !important;
}
.collapsed{
  float: right;
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: Source Han Sans SC, Source Han Sans SC-Medium;
  font-weight: 500;
  text-align: left;
  color: #67b0c4;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.order-title-wrap{
  padding: 25px 28px 17px 27px !important;
}
.orderSearch >>> .el-card{
  border: 0px !important;
}
.buttonSize{
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
}
.disclaimer{
  position: fixed;
  left: 210px;
  bottom: 0;
  right: 0;
  background: #F0F6FC;
  color:#8CA2BD;
  opacity: 0.85;
  font-size:12px;
  height: 36px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  z-index: 3;
}
</style>
